/**
 * Hash a string with SHA-256 → hex
 *
 * @param {string} value - The value to hash (email, phone, etc.)
 * @returns {Promise<string>} - The hex string of the hash
 */
async function sha256(value) {
  if (!value) return '';
  const encoder = new TextEncoder();
  const data = encoder.encode(value.trim().toLowerCase());
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  return Array.from(new Uint8Array(hashBuffer))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}

export default {
  sha256,
};
